import Block from "components/layout/block";
import ListEntitiesTable from "components/list/entities-table";
import { useList } from "stores/hooks/list";

const EntitiesTab = () => {
  const list = useList();

  if (!list) {
    return null;
  }

  return (
    <Block title="Kerättävät kokonaisuudet">
      <ListEntitiesTable list={list} />
    </Block>
  );
};

export default EntitiesTab;
